/**
 * @license hugeicons-react v0.2.0
 *
 * See the LICENSE file in the root directory of this source tree.
 */

import r from"../create-hugeicon-component.js";const o=r("ChartIncreaseIcon",[["path",{d:"M21 21H10C6.70017 21 5.05025 21 4.02513 19.9749C3 18.9497 3 17.2998 3 14V3",stroke:"currentColor",key:"k0"}],["path",{d:"M7.99707 16.999C11.5286 16.999 18.9122 15.5348 18.6979 6.43269M16.4886 8.04302L18.3721 6.14612C18.5656 5.95127 18.8798 5.94981 19.0751 6.14286L20.9971 8.04302",stroke:"currentColor",key:"k1"}]]);export{o as default};
